import React from 'react';
import store from 'app/store';
import uuid from 'node-uuid';

export default function presentModal(modal) {
  return store.get().dispatch(dispatch => {
    const isElement = React.isValidElement(modal);

    if (isElement) {
      const id = modal.key || modal.props.id || uuid.v4();

      return new Promise((resolve, reject) => {
        const originalOnDismiss = modal.props.onDismiss;
        const newModalElement = React.cloneElement(modal, {
          key: id,
          onDismiss(result) {
            try {
              if (typeof originalOnDismiss === 'function') {
                originalOnDismiss(result);
              }
              resolve(result);
            } catch (e) {
              reject(e);
            }
          },
        });
        dispatch({
          type: 'MODAL_EMIT',
          id,
          modal: newModalElement,
        });
      });
    }

    return Promise.reject(new Error('Not a valid React element'));
  });
}
